import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useManageState } from './manageState'
import StateComponents from '../../../../components/state-component/StateComponents'
import { icons } from '../../../../assets/icons/icons'
import { debouncedApiCall } from '../../../../utils/app.utils'
import TableCustom from '../../../../components/table/tableCustom'
import { useNavigate } from 'react-router-dom'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import i18n from '../../../../i18n'
import { useTranslation } from 'react-i18next'

type Props = {
    menu_name?: string;
    button_add_name?: string;
    path_create?: string;
    category?: ELibraryCategory;
    code?: string;
}


const ManageBooks: React.FC<Props> = ({
    menu_name = i18n.t('จัดการหนังสือ') as string,
    category = ELibraryCategory.BOOK,
    button_add_name = i18n.t("เพิ่มหนังสือ") as string,
    path_create = routeName.e_library.manage_books_create,
    code = "e_library_search_global",
}: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {
        path_name,
        set_search,
        handleChangeDateRange,
        end_date,
        start_date,
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        totalItems,
        data,
        set_search_library_type,
        id_library_type,
        set_id_library_type,
        library_type,
        checkPermit
    } = useManageState({ category, code });
    return (
        <ContainerLayout
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library", // i18n-ignore
                            name: t("จัดการข้อมูล E-Library"),
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: 'A',
                            name: menu_name,
                            pathName: path_name
                        },
                    ]}
                />
            }
            title={menu_name}
            content={
                <Box>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                fieldProps: {
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search }),
                                    startAdornment: <Box mr={1}> <icons.SearchNormal /></Box>,
                                    placeholder: t("ค้นหาชื่อ")
                                }
                            },
                            {
                                seq: 2,
                                fieldProps: {
                                    getOptionLabel: (op) => op?.library_type_name || "",
                                    labelId: "12",
                                    options: library_type || [],
                                    value: id_library_type || null,
                                    placeholder: t("ทุกหมวดหมู่"),
                                    onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_library_type }),
                                    onChange: (_, val) => set_id_library_type(val ?? null),
                                },
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                }
                            },
                            {
                                seq: 3,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    placeholder: t("ช่วงวันที่"),
                                    value: {
                                        end_date: end_date,
                                        start_date: start_date
                                    }
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 12,
                                    xl: 3
                                },
                                hidden:!checkPermit.isCreated,
                                fieldProps: {
                                    justifyContent: "flex-end",
                                    buttonData: [
                                        {
                                            seq: 1,
                                            maxWidth: 'fix-content',
                                            buttonProps: {
                                                onClick: () => navigate(path_create)
                                            },
                                            key: button_add_name,
                                            label: button_add_name,
                                            type: "ADD"
                                        }
                                    ],
                                }
                            }
                        ]}
                    />


                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1920}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </Box>
            }
        />
    )
}

export default ManageBooks